import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface BlogCategoryObject {
  id: number;
  titleEn: string;
  titleAr: string;
  isActive: boolean;
  slug: string;
}

export interface BlogCategoriesListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  categories: Array<BlogCategoryObject>;
  errors: unknown;
}

@Module
export default class BlogCategoriesModule
  extends VuexModule
  implements BlogCategoriesListInfo
{
  categories = [] as Array<BlogCategoryObject>;
  allBlogCategories = [] as Array<BlogCategoryObject>;

  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get blog categories list
   * @returns Array<BlogsTagsObject>
   */
  get blogCategoriesList(): Array<BlogCategoryObject> {
    return this.categories;
  }

  /**
   * Get all blog categories list
   * @returns Array<BlogsTagsObject>
   */
  get allListBlogCategories(): Array<BlogCategoryObject> {
    return this.allBlogCategories;
  }

  /**
   * Get total items
   * @returns number
   */
  get categoriesListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_BLOG_CATEGORIES](data) {
    this.categories = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_BLOG_CATEGORIES_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.SET_ALL_BLOG_CATEGORIES](data) {
    this.allBlogCategories = data.data;
  }

  @Mutation
  [Mutations.RESET_BLOG_CATEGORIES_LIST]() {
    this.categories = [] as Array<BlogCategoryObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_BLOG_CATEGORIES_STORE]() {
    this.context.commit(Mutations.RESET_BLOG_TAGS_LIST);
  }

  @Action
  [Actions.CREATE_BLOG_CATEGORY](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/blog-categories', data)
      .then(({ data }) => {
        this.context.commit(Mutations.RESET_BLOG_CATEGORIES_LIST);
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_BLOG_CATEGORY](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/blog-categories', id)
      .then(() => {
        this.context.commit(Mutations.RESET_BLOG_CATEGORIES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_BLOG_CATEGORY]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/blog-categories', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_BLOG_CATEGORIES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_BLOG_CATEGORIES_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_BLOG_CATEGORIES_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_BLOG_CATEGORY](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/blog-categories', id);
  }

  @Action
  [Actions.GET_BLOG_CATEGORIES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/blog-categories', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_BLOG_CATEGORIES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.GET_ALL_BLOG_CATEGORIES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/blog-categories/all')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ALL_BLOG_CATEGORIES, data);
        return data.data;
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
